/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const recruitingVolumeSchema = z.enum(['low', 'mid', 'high', 'unknown'])

export type RecruitingVolumeSchema = z.infer<typeof recruitingVolumeSchema>
